import { Component, Input } from '@angular/core';

import { InsurancePlanCoverageAmount } from '@genesis-frontend/graphql';

@Component({
    selector: 'tiered-coverage-amount',
    templateUrl: './tiered-coverage-amount.component.html',
    styleUrls: ['./tiered-coverage-amount.component.scss']
})
export class TieredCoverageAmountComponent {

    @Input() tieredCoverage: InsurancePlanCoverageAmount[] = [];
    @Input() name = '';
}
